import axios, { AxiosResponse } from 'axios';
import { Message, MessageBox } from 'element-ui';
import { getLanguage, getToken } from '@/utils/auth';
import { UserModule } from '@/store/modules/user';
import { globalData } from './config';
import Axios from 'axios';
import i18n from '../lang';
// 创建axios实例
const service = axios.create({

  baseURL: globalData.domainUrl,
  // 设置默认请求头，使post请求发送的是formdata格式数据// axios的header默认的Content-Type好像是'application/json;charset=UTF-8',我的项目都是用json格式传输，如果需要更改的话，可以用这种方式修改
  // headers: {
  //   'Access-Control-Allow-Origin': '*',
  //   'Access-Control-Allow-Credentials': true,
  //   'Content-Type': 'application/json;charset=utf-8',
  // },
  // withCredentials: true // 允许携带cookie
  timeout: 5000,
});

// service.defaults.baseURL =  globalData.domainUrl;

const codeMessage: any = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};



// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // Add X-Token header to every request, you can add other custom headers here
    const token = getToken();
    if (token) {
      config.headers.token = getToken();
    }
    config.headers.language = getLanguage();

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// 响应拦截器

async function filter<T>(response: AxiosResponse<T>): Promise<T> {
  const res = response.data as any;
  if (response && response.status >= 200 && response.status < 300) {
    // 请求状态正确，但是内部逻辑错误
    const code = (res.code !== null && res.code !== undefined) ? res.code : res.Code;
    console.log(code);
    if (code !== 0 && code !== 1139) {
      let msg = res.msg
      console.log('filter', i18n.t('ErrorMsg')[code.toString()]);
      let errorMsg = i18n.t('ErrorMsg')[code.toString()];
      if (!!errorMsg) {
        msg = errorMsg
      }
      Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000,
      });
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          UserModule.FedLogOut().then(() => {
            location.reload();  // To prevent bugs from vue-router
          });
        });
      }
      // 过期清除token
      if (code === 710) {
        UserModule.FedLogOut().then(() => {
          location.reload();  // To prevent bugs from vue-router
        });
      }
      const errorCode = new Error(res.msg);
      errorCode.name = 'error code:' + res.code;
      return Promise.reject(errorCode);
    } else {
      // 请求状态和 逻辑状态都正确
      return response.data;
    }
  }
  // 请求的状态错误
  const errortext = codeMessage[response.status] || response.statusText;
  const error = new Error(errortext);
  error.name = response.status.toString();
  return Promise.reject(error);
}



export default {
  async post<T = any>(url: string, data?: any) {
    try { //  post
      console.log(url + ' post request ', data);
      const response = await service.request<T>({
        method: 'post',
        url,
        data,
      });

      console.log(url + ' post response', response);
      const final = await filter<T>(response);
      return final;

    } catch (error) {
      // Message({
      //   message: error.message,
      //   type: 'error',
      //   duration: 5 * 1000,
      // });
      // 错误返回空对象
      return {} as T;
    }
  },
  async get<T = any>(url: string, params?: any) { // get
    try {
      console.log(url + ' get request ', params);
      const response = await service.request<T>({
        method: 'get',
        url,
        params,
      });
      console.log(url + ' get response', response);
      const final = await filter<T>(response);
      return final;
    } catch (error) {
      // Message({
      //   message: error.message,
      //   type: 'error',
      //   duration: 5 * 1000,
      // });
      // 错误返回空对象
      return {} as T;
    }
  },
};

